export const toTmsFormat = (inputString: string) => {
        return stripAccents(inputString)
                .replace(/-/g, "_")
                .replace(/'/g, "_")
                .replace(/€/g, "")
                .replace(/\?/g, "")
                .replace(/,[0-9]+/g, "")
                .trim()
                .toLowerCase()
                .split(' ').join('_');
    }
